import { Component } from 'react';
import { CompiledRoutes, S_COMPONENT } from 'src/routing';

export const LANDING_ROUTES = new CompiledRoutes('', {
	[S_COMPONENT]: Component,
});
